import request from './request'

export const fetchInstagramPhotos = () => {
    return new Promise((resolve, reject) => {
        request.get(`instagram`)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
